class NumberedTextArea {
  validator = null;

  constructor ({selector, lineValidation}) {
    this.lineValidation = lineValidation;
    this.$textarea = $(selector);
    this.wrapTextArea();
    this.setupEventListeners();
    this.events = {
      invalid: jQuery.Event('invalid'),
      valid: jQuery.Event('valid'),
      empty: jQuery.Event('empty'),
      input: jQuery.Event('input'),
    };
  }

  wrapTextArea () {
    this.$textarea.wrap('<div class="numbered-textarea-wrapper"></div>');
    this.$wrapper = $('.numbered-textarea-wrapper');
    this.$wrapper.prepend('<div class="numbers"><p class="numbered-textarea-no-1">1</p></div>');
    this.$numbers = $('.numbers');
  }

  triggerEvent (event) {
    $(this).trigger(this.events[event]);
  }

  validateLines () {
    if (!this.$textarea.val()) {
      $('.line-error').removeClass('line-error');
      this.triggerEvent('empty');
      return;
    }

    let scannedSIMs = [];
    let allValid = true;
    let lines = this.$textarea.val().split('\n');
    $.each(lines, (n, line) => {
      let $lineNumber = this.$numbers.find(`p.numbered-textarea-no-${n + 1}`);
      if (!this.lineValidation(line)) {
        $lineNumber.addClass('line-error');
        allValid = false;
      } else {
        $lineNumber.removeClass('line-error');
        let indexCurrentSIM = scannedSIMs.indexOf(line);
        if (indexCurrentSIM === -1) {
          scannedSIMs.push(line);
        } else {
          $lineNumber.addClass('line-error');
          let $duplicateLine = this.$numbers.find(`p.numbered-textarea-no-${indexCurrentSIM + 1}`);
          $duplicateLine.addClass('line-error');
          allValid = false;
        }
      }
    });

    let eventToTrigger = allValid ? 'valid' : 'invalid';
    this.triggerEvent(eventToTrigger);
  }

  setupEventListeners () {
    this.$textarea.on('paste scroll keyup', () => {
      this.$numbers.scrollTop(this.$textarea.scrollTop());
    });

    let timeout;
    this.$textarea.on('keyup paste', () => {
      if (this.validator === null) return;

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.validateLines();
      }, 750);
    });

    this.$textarea.on('change focus blur keyup paste', e => {
      this.triggerEvent('input');
      let lineCount = $(e.currentTarget).val().split('\n').length;
      let numbersCount = this.$numbers.find('p').length;

      if (lineCount > numbersCount) {
        for (let i = numbersCount + 1; i <= lineCount; i++) { // eslint-disable-line no-plusplus
          this.$numbers.append(`<p class="numbered-textarea-no-${i}">${i}</p>`);
        }
      } else {
        for (let n = numbersCount; n > lineCount; n--) { // eslint-disable-line no-plusplus
          this.$numbers.find(`p.numbered-textarea-no-${n}`).remove();
        }
      }
    });
  }

  getLines () {
    let lines = this.$textarea.val().split('\n');
    return lines[0] !== '' ? lines : [];
  }

  static getRegExpLineValidation (regexp) {
    return line => {
      return line.match(regexp);
    };
  }

  get lineValidation () {
    return this.validator;
  }

  set lineValidation (lineValidation) {
    if (lineValidation instanceof Function) {
      this.validator = lineValidation;
    } else if (lineValidation instanceof RegExp) {
      this.validator = NumberedTextArea.getRegExpLineValidation(lineValidation);
    } else {
      this.validator = null;
    }
  }
}

export default NumberedTextArea;
